// VFX: Quote Flyout Card
// Category: ui-elements · Tags: quote, flyout, card, author, text
// Full-width quote with author tag flies in from bottom.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const QUOTE = "Great design is making something memorable and meaningful.";
const AUTHOR = "Dieter Rams";

export default function CardQuoteFlyoutAuthorTag700Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const cardSp = spring({ frame, fps, config: { stiffness: 90, damping: 18, mass: 0.8 } });
  const authorSp = spring({ frame: frame - 8, fps, config: { stiffness: 110, damping: 20 } });

  return (
    <AbsoluteFill style={{
      background: "linear-gradient(135deg, #1e1b4b 0%, #0a0e1a 70%, #1e293b 100%)",
      justifyContent: "center", alignItems: "center", padding: 60,
    }}>
      <div style={{
        background: "rgba(255,255,255,0.05)",
        backdropFilter: "blur(16px)",
        border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: 24,
        padding: "56px 56px 44px",
        maxWidth: 880,
        opacity: cardSp,
        transform: `translateY(${interpolate(cardSp, [0, 1], [80, 0])}px) scale(${interpolate(cardSp, [0, 1], [0.92, 1])})`,
        boxShadow: "0 20px 60px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.08)",
        position: "relative",
      }}>
        {/* Decorative quote mark */}
        <div style={{
          position: "absolute", top: -10, left: 40,
          fontSize: 140, fontFamily: "serif", color: "#a855f7",
          lineHeight: 1, opacity: 0.7,
        }}>“</div>

        <p style={{
          margin: 0, marginTop: 12,
          fontSize: 44, fontWeight: 500, color: "#f8fafc",
          fontFamily: "serif", lineHeight: 1.35, letterSpacing: -0.5,
        }}>{QUOTE}</p>

        {/* Author tag */}
        <div style={{
          marginTop: 32, display: "flex", alignItems: "center", gap: 14,
          opacity: authorSp,
          transform: `translateX(${interpolate(authorSp, [0, 1], [-20, 0])}px)`,
        }}>
          <div style={{
            width: 48, height: 48, borderRadius: "50%",
            background: "linear-gradient(135deg, #a855f7 0%, #06b6d4 100%)",
            display: "flex", justifyContent: "center", alignItems: "center",
            color: "#f8fafc", fontWeight: 800, fontSize: 18, fontFamily: "sans-serif",
          }}>DR</div>
          <div>
            <p style={{ margin: 0, fontSize: 20, fontWeight: 700, color: "#f8fafc", fontFamily: "sans-serif" }}>{AUTHOR}</p>
            <p style={{ margin: 0, fontSize: 14, color: "#94a3b8", fontFamily: "sans-serif" }}>Industrial Designer</p>
          </div>
        </div>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
